import { CropModes, ImageFormats } from '@shared/image/image.config';
import { UmbracoImage } from '@models/umbraco.model';

export const imageScale = (
    image: UmbracoImage,
    width: number,
    height: number,
    crop: CropModes = 'crop',
    format?: ImageFormats,
    quality: number = 75
) => {
    if (!image) {
        return '';
    }

    if (image.extension) {
        format = (image.extension as ImageFormats) ?? 'jpg';
    }

    const imageScalerParams = {
        width,
        height,
        rxy: image.focalPoint ? `${image.focalPoint.left},${image.focalPoint.top}` : null,
        ...(image.ratio ? { heightratio: image.ratio } : undefined),
        ...(format !== 'none' ? { format } : undefined),
        ...(crop !== 'none' ? { rmode: crop } : undefined),
        quality
    };

    // Umbraco adds a 'ud' parameter on all images.
    // We append all params from Umbraco to the end of the src string
    const [src, ...umbracoParams] = image?.src?.split('?') ?? [];
    const params = Object.entries(imageScalerParams)
        .filter(([_, val]) => Boolean(val))
        .map(([key, value]) => `${key}=${value}`)
        .join('&');

    return `${src}?${params}${umbracoParams ? '&' + umbracoParams.toString() : ''}`;
};
